/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react';
import Loginb2cFooter from './loginb2cFooter';
import NewMobileFooter from './newMobileFooter';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import GamesService from '../services/casinoGamesService';
import * as CASINOSHOWLIST from '../configs/casinoShowList';
import Marquee from 'react-fast-marquee';
let oid = OPERATOR_ID.toLowerCase()
export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marquee: 1,
            openGame: false,
            url: null
        };
    }
    // async componentDidMount() {
    //     let accData = JSON.parse(localStorage.getItem("accountData"));
    //     if ((!!accData && Object.keys(accData).length > 0) && (CASINOSHOWLIST.casinoList['INDIANPOKER'].show)) {
    //         const gameRes = await GamesService.getIndividualGame('902000.YG-MLOBBY');
    //         const gameData = gameRes.data;
    //         if (!!gameData && !!gameData.url) {
    //             this.setState({ url: gameData.url })
    //         }
    //     }
    // }

    async setOpenGame(tf) {
        if (tf && (!this.state.url || this.state.url == null)) {
            let accData = JSON.parse(localStorage.getItem("accountData"));
            let self = this
            if (
                !!accData &&
                Object.keys(accData).length > 0 &&
                CASINOSHOWLIST.casinoList["INDIANPOKER"].show
            ) {
                const gameRes = await GamesService.getIndividualGame(
                    "902000.YG-MLOBBY"
                );
                const gameData = gameRes.data;
                if (!!gameData && !!gameData.url) {
                    this.setState({ url: gameData.url }, () => {
                        self.setState({ openGame: tf });
                    });
                } else {
                    this.setState({ openGame: tf });
                }
            } else {
                this.setState({ openGame: tf });
            }
        } else {
            this.setState({ openGame: tf });
        }
    }

    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        const ismob = document.documentElement.clientWidth > 768 ? false : true;
        return (
            <>
                {(!!accData && Object.keys(accData).length > 0) &&
                    <>
                        {(CASINOSHOWLIST.casinoList['INDIANPOKER'].show) && ismob &&
                            <div style={{ position: 'fixed', bottom: '44px', left: '0px', zIndex: 50000, width: '100%', display: this.state.openGame ? 'block' : 'none' }}>
                                <div style={{ width: '100%', height: '18rem' }}>
                                    <div onClick={() => { this.setOpenGame(false) }} style={{ position: "absolute", top: 5, right: 5, width: "30px", textAlign: "center" }}><i style={{ fontSize: 20 }} className="fa fa-times "></i></div>
                                    <iframe title={"iframe_lobby"} key={"iframe_lobby"} src={this.state.url} style={{ width: '100%', height: '100%', border: '0px' }}></iframe>
                                </div>
                            </div>
                        }
                        {/* {ismob && !!this.state.url && <>
                            <div onClick={() => { this.setState({ openGame: true }) }} style={{ position: 'fixed', bottom: '30px', left: '10px', zIndex: 50000, display: !this.state.openGame ? 'block' : 'none' }}>
                                <img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/mini_games.gif"} alt={""}></img>
                            </div>
                        </>} */}
                        {/* <div className="d-flex dpbtnlg dpbtnsm">
                            <div className="mobiledepositbtn exposure-btn w-50 mr-1"><span className='de_wi_font'><i className="fa fa-money" aria-hidden="true"></i> Deposit</span></div>
                            <div className="mobiledepositbtn exposure-btn w-50"><span className='de_wi_font'><i className="fa fa-money" aria-hidden="true"></i> Withdrawal</span></div>
                        </div> */}
                        {CASINOSHOWLIST.LBLTYPE === 'b2c' && profData?.role !== "DemoClient" &&
                            <div className='mobile-deposit-withdraw-btn-dv'>
                                <div className='w-50 mobiledepositbtn' onClick={()=> this.props.history.push('/wallet/deposit')}><i className="fa fa-money" aria-hidden="true"></i> Deposit</div>
                                <div className='w-50 mobilewithdrawalbtn' onClick={()=> this.props.history.push('/wallet/withdraw')}><i className="fa fa-money" aria-hidden="true"></i> Withdrawal</div>
                            </div>
                        }
                        <footer className="container-fluid footer">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12">
                                    {/* <marquee scrollamount="5" behavior="scroll">
                                        <p className="mb-0 font-12"><i className="fa fa-bullhorn mr-2" aria-hidden="true"></i>{this.props.marquee}</p>
                                    </marquee> */}
                                    <Marquee>
                                        <p className="mb-0 font-12"><i className="fa fa-bullhorn mr-2" aria-hidden="true"></i>{this.props.marquee}<span className='mw100'></span></p>
                                    </Marquee>
                                </div>
                            </div>
                        </footer>
                    </>
                }
                <NewMobileFooter history={this.props.history} showSweetAlert={(options) => this.props.showSweetAlert(options)} setOpenGame={(tf) => this.setOpenGame(tf)} notify={this.props.notify} />
            </>
        )
    }
}
